import { IsString } from "class-validator";

export class Cleaning {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  constructor(init?: Cleaning) {
    this.id = init?.id!;
    this.label = init?.label!;
  }
}

export default Cleaning;
